import Nullstack from 'nullstack';
export default function IconBrandTed({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brand-ted",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M2 8h4"
  }), "   ", Nullstack.element("path", {
    d: "M4 8v8"
  }), "   ", Nullstack.element("path", {
    d: "M13 8h-4v8h4"
  }), "   ", Nullstack.element("path", {
    d: "M9 12h2.5"
  }), "   ", Nullstack.element("path", {
    d: "M16 8v8h2a3 3 0 0 0 3 -3v-2a3 3 0 0 0 -3 -3h-2z"
  }), " ");
}